import validationPatterns from './validationPatterns';
export const CA_fieldPatterns = {
  Actor: {
    importerName: {
      ...validationPatterns.U,
      optional: false,
      minLength: 0,
      maxLength: 35,
      fieldName: 'Importer name',
    },
    consigneeName: {
      ...validationPatterns.U,
      optional: false,
      minLength: 0,
      maxLength: 35,
      fieldName: 'Consignee name',
    },
    importerNo: {
      ...validationPatterns.AN,
      optional: false,
      minLength: 15,
      maxLength: 15,
      fieldName: 'Importer number',
    },
    consigneeNo: {
      ...validationPatterns.AN,
      optional: true,
      minLength: 15,
      maxLength: 15,
      fieldName: 'Consignee number',
    },
    importerAddress: {
      ...validationPatterns.P,
      optional: false,
      minLength: 0,
      maxLength: 35,
      fieldName: 'Importer Address',
    },
    importerCity: {
      ...validationPatterns.R,
      optional: false,
      minLength: 0,
      maxLength: 35,
      fieldName: 'Importer City',
    },
    importerState: {
      ...validationPatterns.A,
      optional: false,
      minLength: 0,
      maxLength: 6,
      fieldName: 'Importer State',
      conditions: {
        importerCountry: ['US', 'CA'],
      },
    },
    importerZip: {
      ...validationPatterns.P,
      optional: true,
      minLength: 0,
      maxLength: 9,
      fieldName: 'Importer Zip',
    },
    importerCountry: {
      ...validationPatterns.P,
      optional: true,
      minLength: 0,
      maxLength: 2,
      fieldName: 'Importer Country',
    },
    consigneeAddress: {
      ...validationPatterns.P,
      optional: false,
      minLength: 0,
      maxLength: 35,
      fieldName: 'Consignee Address',
    },
    consigneeCity: {
      ...validationPatterns.R,
      optional: false,
      minLength: 0,
      maxLength: 35,
      fieldName: 'Consignee City',
    },
    consigneeState: {
      ...validationPatterns.A,
      optional: false,
      minLength: 0,
      maxLength: 6,
      fieldName: 'Consignee State',
    },
    consigneeZip: {
      ...validationPatterns.P,
      optional: true,
      minLength: 0,
      maxLength: 9,
      fieldName: 'Consignee Zip',
    },
    consigneeCountry: {
      ...validationPatterns.P,
      optional: true,
      minLength: 0,
      maxLength: 2,
      fieldName: 'Consignee Country',
    },
    manufacturerName: {
      ...validationPatterns.U,
      optional: false,
      minLength: 1,
      maxLength: 70,
      fieldName: 'Manufacturer name',
    },
    manufacturerAddress: {
      ...validationPatterns.P,
      optional: false,
      minLength: 0,
      maxLength: 35,
      fieldName: 'Manufacturer address',
    },
    manufacturer2Address: {
      ...validationPatterns.P,
      optional: true,
      minLength: 0,
      maxLength: 35,
      fieldName: 'Manufacturer address2',
    },
    manufacturerCity: {
      ...validationPatterns.R,
      optional: false,
      minLength: 0,
      maxLength: 35,
      fieldName: 'Manufacturer city',
    },
    manufacturerState: {
      ...validationPatterns.A,
      optional: false,
      minLength: 0,
      maxLength: 25,
      fieldName: 'Manufacturer state',
    },
    manufacturerPostal: {
      ...validationPatterns.P,
      optional: false,
      minLength: 0,
      maxLength: 9,
      fieldName: 'Manufacturer zip',
    },
    manufacturerCountry: {
      ...validationPatterns.A,
      optional: false,
      minLength: 2,
      maxLength: 2,
      fieldName: 'Manufacturer country code',
    },
    vendorName: {
      ...validationPatterns.P,
      optional: false,
      minLength: 1,
      maxLength: 30,
      fieldName: 'Vendor name ',
    },
    vendorAddress: {
      ...validationPatterns.P,
      optional: false,
      minLength: 1,
      maxLength: 35,
      fieldName: 'Vendor address',
    },
    vendor2Address: {
      ...validationPatterns.P,
      optional: true,
      minLength: 0,
      maxLength: 35,
      fieldName: 'Vendor address',
    },
    vendorCity: {
      ...validationPatterns.R,
      optional: false,
      minLength: 0,
      maxLength: 35,
      fieldName: 'Vendor city',
    },
    vendorState: {
      ...validationPatterns.A,
      optional: false,
      minLength: 0,
      maxLength: 25,
      fieldName: 'Vendor state',
    },
    vendorState2: {
      ...validationPatterns.A,
      optional: true,
      minLength: 0,
      maxLength: 25,
      fieldName: 'Vendor state',
    },
    vendorPostal: {
      ...validationPatterns.P,
      optional: true,
      minLength: 0,
      maxLength: 9,
      fieldName: 'Vendor zip',
    },
    vendorPostal2: {
      ...validationPatterns.P,
      optional: false,
      minLength: 0,
      maxLength: 9,
      fieldName: 'Vendor zip',
    },
    vendorCountry: {
      ...validationPatterns.A,
      optional: false,
      minLength: 2,
      maxLength: 2,
      fieldName: 'Vendor country code',
    },
  },

  Shipment: {
    cargoControlNo: {
      ...validationPatterns.P,
      optional: false,
      minLength: 0,
      maxLength: 25,
      fieldName: 'Cargo Control Number',
    },
    transactionNo: {
      ...validationPatterns.P,
      optional: false,
      minLength: 9,
      maxLength: 14,
      fieldName: 'Transaction Number',
    },
    carrierCodeAtImportation: {
      optional: false,
      minLength: 3,
      maxLength: 10,
      fieldName: 'Carrier code at importation',
    },
    voyageTripNo: {
      ...validationPatterns.P,
      optional: true,
      minLength: 0,
      maxLength: 20,
      fieldName: 'Trip no',
    },
    amendmentReasonCode:{
      ...validationPatterns.AN,
      optional: false,
      minLength: 0,
      maxLength: 11,
      fieldName: 'Amendment Reason Code',
      conditions: { transmissionType :'52', isGoodRealesed:false}
    },
    containerNumber: {
      ...validationPatterns.AN,
      optional: true,
      minLength: 0,
      maxLength: 11,
      fieldName: 'Container number',
    },
    estimateArrivalDate: {
      ...validationPatterns.N,
      optional: true,
      minLength: 3,
      maxLength: 10,
      fieldName: 'Estimate arrival date',
    },
    releaseDate: {
      optional: true,
      minLength: 3,
      maxLength: 10,
      fieldName: 'Release date',
    },
    modeOfTransport: {
      ...validationPatterns.A,
      optional: false,
      minLength: 3,
      maxLength: 10,
      fieldName: 'Mode of transport',
    },
    officeNo: {
      ...validationPatterns.N,
      optional: false,
      fieldName: 'Office Number',
    },
    locationOfGoods: {
      ...validationPatterns.N,
      optional: true,
      minLength: 4,
      maxLength: 4,
      fieldName: 'Location of goods',
    },
    portOfUnlading: {
      ...validationPatterns.N,
      optional: false,
      minLength: 3,
      maxLength: 10,
      fieldName: 'Port of unlading',
      conditions: { modeOfTransport: 'Marine' },
    },
    countryOfExport: {
      ...validationPatterns.P,
      optional: false,
      minLength: 2,
      maxLength: 10,
      fieldName: 'Country of export',
    },
    usPortOfExit: {
      ...validationPatterns.N,
      optional: true,
      minLength: 3,
      maxLength: 10,
      fieldName: 'US Port of exit',
    },
    totalPiece: {
      ...validationPatterns.N,
      optional: false,
      minLength: 0,
      maxLength: 100,
      fieldName: 'Total pieces (Quantity)',
    },
    weight: {
      ...validationPatterns.ND2,
      optional: false,
      minLength: 0,
      maxLength: 10,
      fieldName: 'Weight (Quantity)',
    },
    totalVFD: {
      ...validationPatterns.ND2,
      optional: false,
      minLength: 0,
      maxLength: 10,
      fieldName: 'Total VFD',
    },
  },
  Invoice: {
    vendorName: {
      ...validationPatterns.V ,
      optional: false,
      minLength: 1,
      // maxLength: 30,
      fieldName: 'Vendor name ',
    },
    vendorAddress: {
      ...validationPatterns.P,
      optional: false,
      minLength: 1,
      maxLength: 35,
      fieldName: 'Vendor address',
    },
    vendor2Address: {
      ...validationPatterns.P,
      optional: true,
      minLength: 0,
      maxLength: 35,
      fieldName: 'Vendor address',
    },
    vendorCity: {
      ...validationPatterns.R,
      optional: false,
      minLength: 0,
      maxLength: 35,
      fieldName: 'Vendor city',
    },
    vendorState: {
      ...validationPatterns.A,
      optional: false,
      minLength: 0,
      maxLength: 25,
      fieldName: 'Vendor state',
      conditions: {
        vendorCountry: ['US', 'CA'],
      },
    },
    vendorZip: {
      ...validationPatterns.zipCode,
      optional: false,
      minLength: 0,
      maxLength: 9,
      fieldName: 'Vendor zip',
      conditions: {
        vendorCountry: ['US', 'CA'],
      },
    },
    vendorCountry: {
      ...validationPatterns.A,
      optional: false,
      minLength: 2,
      maxLength: 2,
      fieldName: 'Vendor country code',
    },
    invoiceNo: {
      ...validationPatterns.P,
      optional: false,
      minLength: 0,
      maxLength: 35,
      fieldName: 'Invoice number',
    },
    invoiceDate: {
      ...validationPatterns.P,
      optional: false,
      minLength: 3,
      maxLength: 10,
      fieldName: 'Invoice date',
    },
    poNo: {
      ...validationPatterns.P,
      optional: true,
      minLength: 0,
      maxLength: 35,
      fieldName: 'Po number',
    },
    directShipmentDate: {
      ...validationPatterns.N,
      optional: true,
      minLength: 3,
      maxLength: 10,
      fieldName: 'Direct shipment date',
    },
    countryOfOrigin: {
      optional: true,
      fieldName: 'Country of origin',
    },
    tariffTreatment: {
      ...validationPatterns.P,
      optional: true,
      minLength: 3,
      maxLength: 30,
      fieldName: 'Tariff treatment',
    },
    countryOfExport: {
      ...validationPatterns.P,
      optional: true,
      minLength: 2,
      maxLength: 10,
      fieldName: 'Country of export',
    },
    countryOfTranShipment: {
      ...validationPatterns.P,
      optional: true,
      fieldName: 'countryOfTranShipment',
    },
    grossWeight: {
      // ...validationPatterns.N,
      // optional: false,
      // minLength: 1,
      // maxLength: 17,
      // fieldName: 'Gross weight (Quantity)',
    },
    netWeight: {
      ...validationPatterns.N,
      optional: true,
      minLength: 0,
      maxLength: 15,
      fieldName: 'Net weight (Quantity)',
    },
    // totalUnit: {
    //   // ...validationPatterns.N,
    //   // optional: false,
    //   // minLength: 0,
    //   // maxLength: 15,
    //   // fieldName: 'Total unit (Quantity)',
    // },
    package: {
      ...validationPatterns.D,
      optional: false,
      minLength: 0,
      maxLength: 8,
      fieldName: 'Package (Quantity)',
    },
    packageCode: {
      ...validationPatterns.N,
      optional: true,
      fieldName: 'Package code',
      minLength: 0,
      maxLength: 8,
    },
    // invoiceTotal: {
    //   ...validationPatterns.D,
    //   optional: false,
    //   minLength: 0,
    //   maxLength: 12,
    //   fieldName: 'Invoice total',
    // },
    currencyCode: {
      optional: true,
      minLength: 3,
      maxLength: 40,
      fieldName: 'Currency code',
    },
    exchangeRate: {
      ...validationPatterns.D,
      optional: false,
      minLength: 0,
      maxLength: 10,
      fieldName: 'Invoice Exchange rate',
    },
    freight: {
      ...validationPatterns.N,
      optional: true,
      minLength: 0,
      maxLength: 30,
      fieldName: 'Freight',
    },
  },
  Merchandise: {
    classificationNo: {
      ...validationPatterns.P,
      optional: false,
      minLength: 10,
      maxLength: 10,
      fieldName: 'Classification Number',
    },
    tariffCode: {
      ...validationPatterns.N,
      optional: true,
      minLength: 4,
      maxLength: 4,
      fieldName: 'Tariff code',
    },
    countryOfOrigin: {
      ...validationPatterns.P,
      optional: false,
      fieldName: 'Country of origin',
    },
    tariffTreatment: {
      optional: true,
      minLength: 3,
      maxLength: 30,
      fieldName: 'Tariff treatment',
    },
    hsQty: {
      ...validationPatterns.D,
      optional: true,
      minLength: 0,
      maxLength: 9,
      fieldName: 'Hs Quantity',
    },
    hsUOM: {
      optional: true,
      fieldName: 'HS UOM',
    },
    description: {
      ...validationPatterns.V,
      optional: false,
      minLength: 1,
      maxLength: 215,
      fieldName: 'Commercial Description',
    },
    partNo: {
      ...validationPatterns.NF,
      optional: true,
      minLength: 0,
      maxLength: 35,
      fieldName: 'Part Number',
    },
    quantity: {
      ...validationPatterns.D,
      optional: false,
      minLength: 0,
      maxLength: 20,
      fieldName: 'Quantity',
    },
    unitOfMeasurement: {
      ...validationPatterns.PUOM,
      optional: false,
      minLength: 3,
      maxLength: 10,
      fieldName: 'Unit of measurement',
    },
    unitPrice: {
      ...validationPatterns.D,
      optional: false,
      minLength: 0,
      maxLength: 12,
      fieldName: 'Unit price',
    },
    currencyConversionVal: {
      ...validationPatterns.P,
      optional: true,
      minLength: 1,
      maxLength: 10,
      fieldName: 'Currency conversion value',
    },
    rateOfExchange: {
      ...validationPatterns.D,
      optional: false,
      minLength: 0,
      maxLength: 10,
      fieldName: 'Line Rate of exchange',
    },
    valueForDuty: {
      ...validationPatterns.ND,
      optional: false,
      minLength: 0,
      maxLength: 11,
      fieldName: 'Value for duty',
    },
    // rateOfDuty: {
    //   ...validationPatterns.D,
    //   optional: false,
    //   minLength: 0,
    //   maxLength: 20,
    //   fieldName: "Rate of duty",
    // },
    rateOfExcise: {
      ...validationPatterns.D,
      optional: true,
      minLength: 0,
      maxLength: 20,
      fieldName: 'Rate of excise',
    },
    simaCode: {
      ...validationPatterns.N,
      optional: true,
      minLength: 3,
      maxLength: 3,
      fieldName: 'Sima code',
    },
    rateOfGst: {
      ...validationPatterns.N,
      optional: false,
      minLength: 0,
      maxLength: 20,
      fieldName: 'Rate of Gst',
    },
    vfdCode: {
      ...validationPatterns.AN,
      optional: false,
      minLength: 0,
      maxLength: 3,
      fieldName: 'Vfd code',
    },
    customsDuties: {
      ...validationPatterns.D,
      optional: true,
      minLength: 0,
      maxLength: 30,
      fieldName: 'Customs Duties',
    },
    exciseTax: {
      ...validationPatterns.D,
      optional: true,
      minLength: 0,
      maxLength: 10,
      fieldName: 'Excise tax',
    },
    simaAssessment: {
      ...validationPatterns.D,
      optional: true,
      minLength: 0,
      maxLength: 9,
      fieldName: 'Sima assessment',
    },
    totalForTax: {
      ...validationPatterns.D,
      optional: false,
      minLength: 0,
      maxLength: 12,
      fieldName: 'Total for tax',
    },
    gst: {
      ...validationPatterns.D,
      optional: false,
      minLength: 0,
      maxLength: 10,
      fieldName: 'Gst',
    },
    uiElementName: {
      ...validationPatterns.P,
      optional: true,
      minLength: 3,
      maxLength: 10,
      fieldName: 'uiElementName',
    },
    exporterId: {
      optional: true,
      minLength: 15,
      maxLength: 15,
      fieldName: 'exporterId'
    },
    modelId: {
      ...validationPatterns.Alpha,
      optional: true,
      minLength: 1,
      maxLength: 40,
      fieldName: 'modelId'
    },
  },
  CFIA: {
    RegisrationNumber: {
      ...validationPatterns.N,
      optional: true,
      minLength: 1,
      maxLength: 3,
      fieldName: 'Registration Number',
    },
    RegisrationType: {
      ...validationPatterns.N,
      optional: true,
      minLength: 1,
      maxLength: 3,
      fieldName: 'Registration Number',
    },
    DematerializedNumber: {
      ...validationPatterns.N,
      optional: true,
      minLength: 1,
      maxLength: 3,
      fieldName: 'Dematerialized Number',
    },
    DematerializedType: {
      ...validationPatterns.N,
      optional: true,
      minLength: 1,
      maxLength: 3,
      fieldName: 'Dematerialized Number',
    },
    ExtensionCode: {
      ...validationPatterns.AN,
      optional: true,
      minLength: 0,
      maxLength: 6,
      fieldName: 'Extension Code',
    },
    EndUse: {
      ...validationPatterns.N,
      optional: true,
      minLength: 2,
      maxLength: 3,
      fieldName: 'End Use',
    },
    Miscellaneous: {
      ...validationPatterns.N,
      optional: true,
      minLength: 1,
      maxLength: 3,
      fieldName: 'Miscellaneous',
    },
  },
  HC:{
    apiingred: {
      ...validationPatterns.P,
      optional: true,
      minLength: 1,
      maxLength: 35,
      fieldName: 'Ingredients',
    },
    apiIngredQty: {
      ...validationPatterns.N,
      optional: true,
      minLength: 1,
      maxLength: 17,
      fieldName: 'Ingredient Quantity',
    },
    lpcoNum: {
      ...validationPatterns.P,
      optional: true,
      minLength: 1,
      maxLength: 70,
      fieldName: 'Establishment Licence Number',
    }
  }
};
